const selectors = {
    inlineFilters: '[data-inline-filters]',
    productTypeFilter: '[data-product-type-filter]',
};
const classes = {
    inlineFiltersReady: 'filter__inline-filters--ready',
};
const productCollection = () => {
    const events = ['load', 'frank-green:filters-ready'];
    events.forEach((event) => {
        window.addEventListener(event, () => {
            const inlineFilters = document.querySelector(selectors.inlineFilters);
            if (inlineFilters) {
                inlineFilters.innerHTML = '';
                const productTypeFilters = document.querySelectorAll(selectors.productTypeFilter);
                productTypeFilters.forEach((filter) => {
                    let filterStatus = '';
                    const filterValue = filter.getAttribute('value');
                    const filterClone = document.createElement('div');
                    if (filter.hasAttribute('disabled')) {
                        filterStatus = 'disabled';
                    }
                    if (filter.checked) {
                        filterStatus = 'active';
                    }
                    filterClone.setAttribute('data-product-type-filter-value', filterValue);
                    filterClone.setAttribute('data-product-type-filter-status', filterStatus);
                    filterClone.innerHTML = filterValue;
                    inlineFilters.append(filterClone);
                    filterClone.addEventListener('click', () => {
                        filter.click();
                    });
                });
                inlineFilters.classList.add(classes.inlineFiltersReady);
            }
        });
    });
};
export { productCollection };
